import {
    RECEIVE_NEXT_STEP_FLOW,
    REQUEST_NEXT_STEP_FLOW,
    RECEIVE_LETS_GET_STARTED_FLOW,
    REQUEST_LETS_GET_STARTED_FLOW,
    REMOVE_NEXT_STEP,
    UPDATE_GETSTARTED_UPDATE_STATUS,
    INextStepFlowState,
    NextStepFlowTypes,
    COMPLETE_GET_STARTED_FLOW,
    HIDE_GET_STARTED_ON_CURRENT_SESSION,
} from "./types";

const initialState: INextStepFlowState = {
    flows: [],
    userLetsGetStartedFlows: [],
    isGetStaredUpdatedInCurrentLoginSession: false,
};

export function nextStepFlowReducer(state = initialState, action: NextStepFlowTypes): INextStepFlowState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_NEXT_STEP_FLOW:
            return {
                ...state,
                flows: state.flows,
            };
        case UPDATE_GETSTARTED_UPDATE_STATUS:
            return {
                ...state,
                isGetStaredUpdatedInCurrentLoginSession: true,
            };
        case HIDE_GET_STARTED_ON_CURRENT_SESSION:
            return {
                ...state,
                isGetStaredUpdatedInCurrentLoginSession: false,
            };
        case RECEIVE_NEXT_STEP_FLOW:
            return {
                ...state,
                flows: action.flows,
            };

        case REQUEST_LETS_GET_STARTED_FLOW:
            return {
                ...state,
                userLetsGetStartedFlows: state.userLetsGetStartedFlows,
            };
        case COMPLETE_GET_STARTED_FLOW:
            const itemIndex = state.userLetsGetStartedFlows.findIndex((item) => item.flowStepId === action.flowID);

            return {
                ...state,
                userLetsGetStartedFlows: [
                    ...state.userLetsGetStartedFlows.slice(0, itemIndex),
                    {
                        ...state.userLetsGetStartedFlows[itemIndex],
                        flowStepStatus: "COMPLETED",
                    },
                    ...state.userLetsGetStartedFlows.slice(itemIndex + 1),
                ],
            };
        case RECEIVE_LETS_GET_STARTED_FLOW:
            return {
                ...state,
                userLetsGetStartedFlows: action.userLetsGetStartedFlows,
            };

        case REMOVE_NEXT_STEP:
            const index = state.flows.findIndex((item) => item.flowName === action.flowName);

            return {
                ...state,
                flows: [...state.flows.slice(0, index), ...state.flows.slice(index + 1)],
            };
        default:
            return state;
    }
}
